import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  openFlg: false,
  key: null
}

export const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    toggleDrawer: (state, action) => {
      return {
        ...state,
        openFlg: action.payload.openFlg,
        key: action.payload.key
      }
    },
    openDrawer: (state) => {
      state.openFlg = true
    },
    closeDrawer: (state) => {
      state.openFlg = false
    },
  }
})

export const { toggleDrawer, openDrawer, closeDrawer } = drawerSlice.actions

export default drawerSlice.reducer